import React, { useMemo, useEffect } from 'react';
import ChatWindow from '@components/Chat/ChatWindow';
import './App.css';

function App() {
  // Read language from query parameter, default to 'ar'
  const { lang, dir } = useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const langParam = urlParams.get('lang')?.toLowerCase();
    
    // Normalize language: only 'en' is explicitly English, everything else defaults to Arabic
    const language = langParam === 'en' ? 'en' : 'ar';
    const direction = language === 'ar' ? 'rtl' : 'ltr';
    
    console.log(`🌐 [App] Language from URL: ${langParam || 'not set'} → using: ${language}`);
    
    return { lang: language, dir: direction };
  }, []);

  // Update page title based on language
  useEffect(() => {
    document.title = lang === 'en' 
      ? 'Smart Assistant - Nama' 
      : 'المساعد الافتراضي - نما';
  }, [lang]);

  return (
    <div className="app" dir={dir}>
      <ChatWindow isWidget={false} lang={lang} dir={dir} />
    </div>
  );
}

export default App;




